import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { CSSEvent } from '../../types/model';
import { Page } from '../../types/Seo';
import {
  getSelectedStore,
  getStores,
  useAppContext,
} from '../../contextProviders/AppContext';
import getEventDetailsSeo from './getEventDetailsSeo';
import { EVENT_DETAILS, EVENT_LIST, EVENT_STORE_LIST, REGISTER } from './enums';
import getEventListSeo from './getEventListSeo';
import { config as CSSConfig } from '../../config';

type PropsType = {
  event?: CSSEvent;
  page: Page;
  canonicalPath?: string;
};

const Seo = ({ event, page, canonicalPath }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const selectedStore = useSelector(getSelectedStore);
  const stores = useSelector(getStores);
  let config = null;
  let title;
  const isEventActive = event?.visibilityState === 'ACTIVE';

  if (page === EVENT_DETAILS && event) {
    config = getEventDetailsSeo(stores, event, t);
  } else if ([EVENT_LIST, EVENT_STORE_LIST].indexOf(page) > -1) {
    config = getEventListSeo(selectedStore, page, t);
  }else if (page === REGISTER){
    title = t('register.registerTitle',{ eventName: event?.eventDetails.eventName});
  }
  return (
    <Helmet
      defaultTitle={t('storeEventCustomer.title')}
      title={config?.title ? config?.title: title}
      meta={config?.meta}
    >
      {config?.jsonLd && isEventActive && (
        <script type="application/ld+json">
          {JSON.stringify(config?.jsonLd, null, 2)}
        </script>
      )}
      {config?.canonicalPath && (
        <link
          rel="canonical"
          href={`${CSSConfig.canonicalHost}${canonicalPath}`}
        />
      )}
      ;
    </Helmet>
  );
};

export default Seo;
